/**
 * 展示维度 icon 契约类型。
 *
 * @see constants.ts · config.ts · utils.ts
 */

/**
 * icon 选择弹窗左侧 Tab 分类（value 与 i18n key 后缀一致）。
 *
 * @core DimensionMapSetModal 与 dimensionIconPickerSearch 共用分类 key；放 SortableDrag 会导致 AliTableAnalytics 反向依赖页面。
 */
export const DimensionIconCategory = {
  Platform: 'platform',
  Sentiment: 'sentiment',
  Country: 'country',
  Others: 'others',
} as const;

export type TDimensionIconCategory =
  (typeof DimensionIconCategory)[keyof typeof DimensionIconCategory];

/** 维度趋势图 icon：URL 资源（img）。 */
export interface IDimensionTrendIconUrlEntry {
  icon: string;
  disableIcon: string;
  color?: string;
  cololist?: readonly string[];
}

/**
 * 维度趋势图 icon：与舆情等模块共用的 home iconfont
 *（SvgIcon 的 type 不含 tea-icon- 前缀）。
 */
export interface IDimensionTrendIconIconfontEntry {
  iconfontType: string;
  disableIconfontType: string;
  cololist: readonly string[];
}

export type IDimensionTrendIconMeta =
  | IDimensionTrendIconUrlEntry
  | IDimensionTrendIconIconfontEntry;
